import accommodation from './public/accommodation.png';
import idea from './public/pin.png';
import restaurant from './public/restaurant.png';
import shopping from './public/shopping.png';

const IDEA_ICONS = {
  ACCOMMODATION: accommodation,
  IDEA: idea,
  RESTAURANT: restaurant,
  SHOPPING: shopping
}

export default IDEA_ICONS;
